const SharedReducer = (state, action) => {
  return state;
};

export default SharedReducer;
